import { useEffect, useState } from "react";
import {
  getVerticalsList,
  getRefTypes,
} from "../Services/Dashboard/salesPersonGridService";
import { useQuery } from "react-query";

export const useVerticals = () => {
  const verticalsQuery = useQuery("verticalsList", () =>
    getVerticalsList({
      inputParameters: {
        queryName: "fetch_verticals",
      },
    }), {
      enabled: false
    }
  );

  const fetchVerticals = () => {
    verticalsQuery.refetch();
  };

  return { ...verticalsQuery, fetchVerticals };
};

export const useRefTypes = (verticals) => {
  const [refTypes, setRefTypes] = useState([]);

  useEffect(() => {
    if (verticals?.length > 0) {
      fetchRefTypes();
    }
  }, [verticals]);

  const fetchRefTypes = async (id = verticals[0].id) => {
    const data = {
      input: {
        refType: "Vertical",
        refValue: verticals?.filter((item) => Number(item.id) === Number(id))[0]
          ?.refValue,
      },
    };

    await getRefTypes(data).then((res) => {
      const refTypes = res?.data?.data?.map((item) => item.refType);
      const uniqueRefTypes = [...new Set(refTypes)];
      setRefTypes(uniqueRefTypes);
    });
  };
  return [refTypes, fetchRefTypes];
};
